import { Button } from "reactstrap";
import { mainButtonStyles } from "../styles/mainStyles";

function MainButton({ onClick, title, size = "lg" }) {
    return (
        <>
            <Button
                onClick={onClick}
                style={mainButtonStyles}
                size={size}
                onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseOut={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
                }
            >
                {title}
            </Button>
        </>
    );
}

export default MainButton;
